// src/OrderSuccess.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTheme } from "./contexts/ThemeContext";
import logo from "./assets/logo.png";
import { Sun, Moon } from "lucide-react"; // <-- added icons

export default function OrderSuccess() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { darkMode, setDarkMode } = useTheme(); // <-- fixed

  const shortId = orderId.toUpperCase();

  return (
    <div className={darkMode ? "dark" : ""}>
      <div className="min-h-screen bg-gradient-to-b from-pink-100 to-white dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-200 font-sans">

        {/* HEADER */}
        <header className="w-full py-4 shadow-sm bg-white/80 dark:bg-gray-900/80 backdrop-blur-md sticky top-0 z-50">
          <div className="max-w-6xl mx-auto flex items-center justify-between px-4">

            {/* Logo + Home */}
            <div
              className="flex items-center gap-3 cursor-pointer"
              onClick={() => navigate("/")}
            >

              <img
                src={logo}
                alt="Bubble Butter Logo"
              //  className="h-10 w-10 object-cover rounded-full shadow-sm"
                className="h-10 w-14 object-cover rounded-xl shadow-sm"
              />

              <h1 className="text-2xl md:text-3xl font-bold text-pink-600 dark:text-pink-300">
                Bubble Butter
              </h1>
            </div>

            {/* Right Buttons */}
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate("/")}
                className="px-4 py-2 rounded-lg bg-pink-600 hover:bg-pink-700 text-white shadow-sm"
              >
                Home
              </button>

              {/* 🔥 Updated theme toggle button */}
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-700 dark:text-white shadow-sm flex items-center justify-center"
              >
                {darkMode ? <Sun size={20} /> : <Moon size={20} />}
              </button>
            </div>
          </div>
        </header>

        {/* SUCCESS MESSAGE */}
        <div className="flex flex-col items-center justify-center p-6 pt-10 text-center">


          <img
            src={logo}
            alt="Bubble Butter"
          // className="h-24 w-24 mb-6 rounded-full shadow-lg"
            className="h-24 w-36 mb-6 rounded-xl shadow-lg"
          />



          <h1 className="text-3xl font-extrabold text-pink-600 dark:text-pink-300 mb-4">
            🎉 Order Placed Successfully!
          </h1>

          <p className="text-lg text-gray-600 dark:text-gray-300 mb-3">
            Thank you for your purchase!
          </p>

          <p className="text-xl font-semibold bg-white dark:bg-gray-800 shadow px-6 py-3 rounded-xl border border-pink-300 dark:border-pink-500 mb-8">
            Order ID:&nbsp;
            <span className="text-pink-600 dark:text-pink-300 font-mono tracking-wider">
              {shortId}
            </span>
            <br />
            <span className="text-xs text-gray-500 dark:text-gray-400">
              (Full ID stored in database)
            </span>
          </p>

          {/* ACTION BUTTONS */}
          <div className="flex gap-4 mt-4">
            <button
              onClick={() => navigate(`/order/${orderId}`)}
              className="px-5 py-3 rounded-xl bg-pink-600 hover:bg-pink-700 text-white shadow-lg transition w-40"
            >
              View Order
            </button>

            <button
              onClick={() => navigate("/products")}
              className="px-5 py-3 rounded-xl bg-pink-600 hover:bg-pink-700 text-white shadow-lg transition w-40"
            >
              Continue Shopping
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
